export const CURRENT_URL = `${window.location.protocol}//${window.location.host}`;
export const API_URL = `${CURRENT_URL}/wp-json/tmt-insurance/v1`;

const eventMetaUrl = `${API_URL}/event-meta`;

export const getEventMeta = async () => {
  const response = await fetch(eventMetaUrl);

  if (!response.ok) {
    throw new Error(`Response status: ${response.status}`);
  }

  const json = await response.json();
  return json;
};
